<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="申请编号" prop="limitApply">
          <el-input v-model="dataForm.limitApply" placeholder="申请编号"></el-input>
      </el-form-item>
          <el-form-item label="企业名称" prop="customerName">
          <el-input v-model="dataForm.customerName" placeholder="企业名称"></el-input>
      </el-form-item>
          <el-form-item label="渠道号" prop="channelNum">
          <el-input v-model="dataForm.channelNum" placeholder="渠道号"></el-input>
      </el-form-item>
          <el-form-item label="授信状态" prop="limitStatus">
          <el-input v-model="dataForm.limitStatus" placeholder="授信状态"></el-input>
      </el-form-item>
          <el-form-item label="申请时间" prop="applyTime">
          <el-input v-model="dataForm.applyTime" placeholder="申请时间"></el-input>
      </el-form-item>
          <el-form-item label="授信时间" prop="limitTime">
          <el-input v-model="dataForm.limitTime" placeholder="授信时间"></el-input>
      </el-form-item>
          <el-form-item label="授信额度" prop="limitAmount">
          <el-input v-model="dataForm.limitAmount" placeholder="授信额度"></el-input>
      </el-form-item>
          <el-form-item label="额度到期日" prop="limitEndTime">
          <el-input v-model="dataForm.limitEndTime" placeholder="额度到期日"></el-input>
      </el-form-item>
          <el-form-item label="推荐官邀请码" prop="yrymInvitationCode">
          <el-input v-model="dataForm.yrymInvitationCode" placeholder="推荐官邀请码"></el-input>
      </el-form-item>
          <el-form-item label="团队长邀请码" prop="yrymCaptainCode">
          <el-input v-model="dataForm.yrymCaptainCode" placeholder="团队长邀请码"></el-input>
      </el-form-item>
          <el-form-item label="管理员邀请码" prop="yrymAdminCode">
          <el-input v-model="dataForm.yrymAdminCode" placeholder="管理员邀请码"></el-input>
      </el-form-item>
          <el-form-item label="时长是否满足要求" prop="timeDemand">
          <el-input v-model="dataForm.timeDemand" placeholder="时长是否满足要求"></el-input>
      </el-form-item>
          <el-form-item label="金额是否满足要求" prop="amountDemand">
          <el-input v-model="dataForm.amountDemand" placeholder="金额是否满足要求"></el-input>
      </el-form-item>
          <el-form-item label="提款是否满足要求" prop="drawMoneyDemand">
          <el-input v-model="dataForm.drawMoneyDemand" placeholder="提款是否满足要求"></el-input>
      </el-form-item>
          </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        limitApply: '',
        customerName: '',
        channelNum: '',
        limitStatus: '',
        applyTime: '',
        limitTime: '',
        limitAmount: '',
        limitEndTime: '',
        yrymInvitationCode: '',
        yrymCaptainCode: '',
        yrymAdminCode: '',
        timeDemand: '',
        amountDemand: '',
        drawMoneyDemand: '',
        creator: '',
        createDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        limitApply: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        customerName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelNum: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        applyTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitEndTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        yrymInvitationCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        yrymCaptainCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        yrymAdminCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        timeDemand: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        amountDemand: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        drawMoneyDemand: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/nbbankfiles/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/nbbankfiles/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
